export default (value: any) => (typeof value === 'boolean' ? value : undefined);
